import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

export interface ProductoActivo {
    nombre: string;
    poliza: string;
    estado: string;
    vigencia: string;
    branchType?: string;
}

@Component({
    selector: 'app-active-products',
    templateUrl: './active-products.component.html',
    styleUrls: ['./active-products.component.scss']
})
export class ActiveProductsComponent {

    @Input() productos: ProductoActivo[] = [];
    @Input() loading: boolean = false;

    skeletonSlots: number[] = [0, 1, 2];

    constructor(private router: Router) {}

    get items(): ProductoActivo[] {
        return (this.productos || []).slice(0, 4);
    }

    irA(link: string): void {
        this.router.navigate([link]);
    }

    iconForProduct(p: ProductoActivo): string {
        const base = 'resources/assets/images/main-page/';
        const key = ((p && p.branchType) || '').toLowerCase().trim();
        const fileMap: { [k: string]: string } = {
            legal:        'onlygal-abogado-365.svg',
            abogado:      'onlygal-abogado-365.svg',
            lawyer:       'onlygal-abogado-365.svg',
            travel:       'onlygal-asistencia-viaje.svg',
            viaje:        'onlygal-asistencia-viaje.svg',
            trip:         'onlygal-asistencia-viaje.svg',
            compraventa:  'onlygal-compraventa-asegurada.svg',
            home:         'onlygal-compraventa-asegurada.svg',
            vivienda:     'onlygal-compraventa-asegurada.svg',
            inmueble:     'onlygal-compraventa-asegurada.svg',
            car:          'car.svg',
            coche:        'car.svg',
            vehiculo:     'car.svg'
        };
        let file = 'bag-2.svg';
        for (const k of Object.keys(fileMap)) {
            if (key.indexOf(k) !== -1) { file = fileMap[k]; break; }
        }
        return base + file;
    }
}
